import { IBaseModel, ListQueryParam } from '../models';
import { IResponseMessages } from '../models/response-messages.model';
import { NewReadOnlyClient } from './new-read-only.client';

export abstract class NewBaseClient<
    DataModel,
    ResponseModel = IBaseModel,
    QueryModel extends ListQueryParam = ListQueryParam,
> extends NewReadOnlyClient<ResponseModel, QueryModel> {
    public async createOne(data: DataModel, messages?: IResponseMessages): Promise<string> {
        const { data: response } = await this.api.post<IBaseModel>(`${this.basePath}`, data, {
            successMessage: messages?.onCreateSuccessMessage,
            errorMessage: messages?.onCreateErrorMessage,
        });
        return response.id;
    }

    public async updateOne(id: string, data: DataModel, messages?: IResponseMessages): Promise<string> {
        await this.api.put<IBaseModel>(`${this.basePath}/${id}`, data, {
            successMessage: messages?.onUpdateSuccessMessage,
            errorMessage: messages?.onUpdateErrorMessage,
        });
        return id;
    }

    public async deleteOne(id: string, messages?: IResponseMessages): Promise<void> {
        return this.api.delete(`${this.basePath}/${id}`, {
            successMessage: messages?.onDeleteSuccessMessage,
            errorMessage: messages?.onDeleteErrorMessage,
        });
    }
}
